/** Detect NICE ACD InvalidContactId on disposition save. */
export function isInvalidContactIdError(error: unknown): boolean {
  const sdkError = error as {
    data?: {
      body?: { error_description?: string; error?: string };
      error_description?: string;
    };
    message?: string;
    error_description?: string;
  };

  const description =
    sdkError.data?.body?.error_description ||
    sdkError.data?.error_description ||
    sdkError.error_description ||
    '';

  return (
    description === 'InvalidContactId' || sdkError.message?.includes('InvalidContactId') === true
  );
}
